import * as React from 'react';

// API
import apibridge from '../apibridge';

// UTILS
import { listenForOutsideClicks } from '../utils';

// COMPONENTS
import CircleImage from './CircleImage';

// ICONS
import { ReactComponent as SeachIcon } from '../assets/svg/search.svg';

// TYPES
import { OrganisationAdministratorCandidatesUserProfile } from '../api/models';

export interface SearchOrganisationMembersTypes {
	placeholder?: string;
	onChange?: any;
	isFullWidth?: boolean;
	id?: string;
}

const SearchOrganisationMembers: React.FC<SearchOrganisationMembersTypes> = ({
	placeholder = 'Search...',
	onChange,
	isFullWidth,
	id
}) => {
	const [query, setQuery] = React.useState<string | undefined>('');
	const [searchResults, setSearchResults] = React.useState<OrganisationAdministratorCandidatesUserProfile[]>([]);
	const [hasError, setHasError] = React.useState<boolean>(false);
	const [isActive, setIsActive] = React.useState<boolean>(false);

	const searchData = async (name: string) => {
		const response = await apibridge.getOrganisationAdminCandidates(id, name);

		if (!response.isError && response.result) {
			setHasError(false);
			setSearchResults(response.result);
		} else {
			setHasError(true);
		}
	};

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const val = e.target.value;

		setQuery(val);

		if (onChange) {
			onChange(undefined);
		}

		if (!val) {
			setIsActive(false);
		} else {
			setIsActive(true);
			searchData(val);
		}
	};

	const onClickPostHandler = (item: OrganisationAdministratorCandidatesUserProfile) => {
		setIsActive(false);
		setQuery('');

		if (onChange) {
			onChange(item);
		}
	};

	//  Logic to detect outside click and close search container
	const searchContainerRef = React.useRef(null);
	listenForOutsideClicks(searchContainerRef, isActive, setIsActive);

	return (
		<div className={`search-wrapper`}>
			<div className={`search-input-container ${isActive ? 'active' : ''} ${isFullWidth ? 'w-100' : ''}`}>
				<SeachIcon className="search-icon" />
				<input
					className="search-input"
					type="text"
					placeholder={placeholder}
					value={query}
					onChange={onChangeHandler}
					onClick={() => setIsActive(!!query)}
				/>
			</div>

			{(hasError || searchResults) && (
				<div
					ref={searchContainerRef}
					className={`search-result-container ${isActive ? 'active' : ''} ${isFullWidth ? 'w-100' : ''}`}
				>
					<ul>
						{hasError ? (
							<li className="search-result-item">No results found</li>
						) : (
							searchResults.map((item) => {
								return (
									<li onClick={() => onClickPostHandler(item)} key={item.id} className="search-result-item">
										<CircleImage src={item.profileImage} isColorBorder={true} size={32} />
										<div className="item-left">
											<span className="name">{item.name}</span>
										</div>
										<div className="item-right">{item.staffType}</div>
									</li>
								);
							})
						)}
					</ul>
				</div>
			)}
		</div>
	);
};

export default SearchOrganisationMembers;
